import { Suspense, lazy, useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { useAppDispatch, useAppSelector } from '../../../../../hooks/useRedux';
import { IPromoData, resetLandingStates, setHomeData, setLandingActive } from '../../../../../redux/landingSlice';
import APIKit from '../../../../../utils/APIKit';
import CoverTopGeneric from '../coverTopGeneric/CoverTopGeneric';
import getSelectedPlan from '@/utils/getSelectedPlan';

const CoverTopPromo = lazy(() => import('../coverTopPromo/generic/CoverTopPromo'));

const CoverTopHome = () => {
    const selectedPlanId = useAppSelector((state) => state.plan.currentPlan);
    const promoIsActive = useAppSelector((state) => state.landing.isActive);
    const globalCountdown = useAppSelector((state) => state.landing.homeCoverPromoData.countdown);
    const { isAloyPlan } = getSelectedPlan(selectedPlanId);
    const dispatch = useAppDispatch();
    const { i18n } = useTranslation();
    // const landingInfoIsLoading = useRef<boolean>(false);
    const showPromoCover = promoIsActive && !isAloyPlan;

    // const getPromoInfo = () => {
    //     if (landingInfoIsLoading.current) return;
    //     landingInfoIsLoading.current = true;
    //     APIKit.get('landing/page/valentine/')
    //         .then((res) => {
    //             const promoData: IPromoData = res.data;
    //             dispatch(setHomeData(promoData));
    //         })
    //         .catch(() => {
    //             if (promoIsActive) dispatch(resetLandingStates());
    //         })
    //         .finally(() => {
    //             landingInfoIsLoading.current = false;
    //         });
    // };

    const checkIfPromoIsActive = () => {
        if (globalCountdown) return dispatch(setLandingActive(true));
        if (promoIsActive) return dispatch(resetLandingStates());
        return false;
    };

    useEffect(() => {
        checkIfPromoIsActive();
    }, [globalCountdown]);

    // useEffect(() => {
    //     getPromoInfo();
    // }, [i18n.language]);

    return showPromoCover ? (
        <Suspense fallback={<CoverTopGeneric />}>
            <CoverTopPromo />
        </Suspense>
    ) : (
        <CoverTopGeneric />
    );
};

export default CoverTopHome;
